import React from "react";
import { PageSettings } from "./config/page-settings.js";
import Content from "./components/content";
import SweetAlert from "react-bootstrap-sweetalert";
import LoadingOverlay from "react-loading-overlay";
import { connect } from "react-redux";
import {
  updateLoginUser,
  resetLogin,
  performLogout,
  checkIsLoggedIn,
} from "./redux/AuthAction.js";
import { disposeMessage } from './redux/AppAction.js';
import classNames from "classnames";
import { isObjectEmpty, stringIsNullOrEmpty, injectMetaPixel, injectExoClickGoalTag } from "./util/Util.js";
import { withTranslation } from "react-i18next";
import { Helmet } from 'react-helmet';
import ApiEngine from './util/ApiEngine.js';
import { ApiKey, ApiUrl, hostnameExoMapping, getHostnamePixelId, LanguageOption} from "./util/Constant";

LoadingOverlay.propTypes = undefined; 

function safeJsonParse(value) {
  if (value == null || value === '') {
    return null;
  }
  try {
    return JSON.parse(value);
  } catch (e) {
    return null;
  }
}

class App extends React.Component {
  constructor(props) {
    super(props);

    this.handleSetPageContent = (value) => {
      this.setState((state) => ({
        pageContent: value,
      }));
    };
    this.handleSetPageContentClass = (value) => {
      this.setState((state) => ({
        pageContentClass: value,
      }));
    };
    this.handleSetPageContentFullHeight = (value) => {
      this.setState((state) => ({
        pageContentFullHeight: value,
      }));
    };
    this.handleSetPageContentFullWidth = (value) => {
      this.setState((state) => ({
        pageContentFullWidth: value,
      }));
    };
    this.handleSetPageContentInverseMode = (value) => {
      this.setState((state) => ({
        pageContentInverseMode: value,
      }));
    };
    this.handleSetPageFooter = (value) => {
      this.setState((state) => ({
        pageFooter: value,
      }));
    };
    this.handleSetBodyWhiteBg = (value) => {
      if (value === true) {
        document.body.classList.add("bg-white");
      } else {
        document.body.classList.remove("bg-white");
      }
    };

    this.state = {
      pageContent: true,
      pageContentClass: "",
      pageContentFullHeight: false,
      pageContentFullWidth: true,
      pageContentInverseMode: false,
      handleSetPageContent: this.handleSetPageContent,
      handleSetPageContentClass: this.handleSetPageContentClass,
      handleSetPageContentFullHeight: this.handleSetPageContentFullHeight,
      handleSetPageContentFullWidth: this.handleSetPageContentFullWidth,
      handleSetPageContentInverseMode: this.handleSetPageContentInverseMode,

      pageFooter: false,
      handleSetPageFooter: this.handleSetPageFooter,
      error: null,
      errorInfo: null,

      handleSetBodyWhiteBg: this.handleSetBodyWhiteBg,
      handleSetPageBoxedLayout: this.handleSetPageBoxedLayout,

      location: window.location.href,
      language: this.props.i18n.language,
      _lastViewport: { width: 0, height: 0 },
    };

    // NEW: ResizeObserver handler
    this._resizeObserver = null;
    this._checkAuthInterval = null;
    this._lastSeoKey = null;
    this._seoFetchInFlight = null;
    this._handleViewportChange = (entries) => {
      for (const entry of entries) {
        const { width, height } = entry.contentRect;
        const w = Math.round(width);
        const h = Math.round(height);

        if (w !== this.state._lastViewport.width || h !== this.state._lastViewport.height) {
          this.checkAndRedirectMobile(); // Trigger redirect check
          this.setState({ _lastViewport: { width: w, height: h } });
        }
      }
    };
  }

  // NEW: Centralized mobile redirect logic (replaces old inline checkAndRedirect)
  checkAndRedirectMobile = () => {
    if (typeof window === 'undefined') return;
    const isMobile = document.documentElement.clientWidth < 768 || window.innerWidth < 768;
    const isLocalhost = window.location.href === 'http://localhost:54006/';

    if (isMobile && !isLocalhost) {
      let currHref = window.location.href;
      let currHostname = window.location.hostname;
      let newHref = '';

      if (currHostname.includes('-d.')) {
        newHref = currHref.replace('-d.', '.');
      } else {
        let dotCount = currHref.split(".").length - 1;
        if (dotCount === 1) {
          var tempCount = ('https://').length;
          newHref = 'https://m.' + currHref.substring(currHref.indexOf('https://') + tempCount);
        } else if (dotCount === 2) {
          newHref = currHref.substring(0, currHref.indexOf(".")) + "-m" + currHref.substring(currHref.indexOf("."), currHref.length);
        }
      }
      if (newHref) {
        window.location.href = newHref;
      }
    }
  };

  /// <summary>
  /// Author: -
  /// </summary>
  componentDidMount() {
    this.props.checkIsLoggedIn().then(() => {
      // Once the check is completed, handle the interval logic
      this.startOrStopInterval();
    });

    const pixelId = getHostnamePixelId(window.location.hostname);
    if (pixelId) {
        injectMetaPixel(pixelId);
    }

    const exoId = hostnameExoMapping[window.location.hostname]; 
    if (exoId) {
        injectExoClickGoalTag(exoId);
    }

    this.scheduleSeoFetch(this.props.i18n.language);

    // 1. Initial redirect check
    this.checkAndRedirectMobile();

    // 2. Start ResizeObserver � detects DevTools device switches
    this._resizeObserver = new ResizeObserver(this._handleViewportChange);
    this._resizeObserver.observe(document.documentElement);

    // 3. Fallback: Debounced resize listener (for non-DevTools cases)
    let lastWidth = document.documentElement.clientWidth;
    this.resizeTimeout = null;

    const handleDevToolsResize = () => {
      const currentWidth = document.documentElement.clientWidth;
      if (Math.abs(currentWidth - lastWidth) > 50) {
        clearTimeout(this.resizeTimeout);
        this.resizeTimeout = setTimeout(() => {
          this.checkAndRedirectMobile();
          lastWidth = currentWidth;
        }, 300);
      } else {
        lastWidth = currentWidth;
      }
    };

    window.addEventListener('resize', handleDevToolsResize);

    this._devToolsResizeHandler = handleDevToolsResize;
  }

  componentWillUnmount() {
    this.stopInterval();

    // NEW: Disconnect ResizeObserver
    if (this._resizeObserver) {
      this._resizeObserver.disconnect();
      this._resizeObserver = null;
    }

    if (this._devToolsResizeHandler) {
      window.removeEventListener('resize', this._devToolsResizeHandler);
      this._devToolsResizeHandler = null;
    }
    if (this.resizeTimeout) {
      clearTimeout(this.resizeTimeout);
    }
  }

  /// <summary>
  /// Author: -
  /// </summary>
  componentDidUpdate(prevProps) {
    if (this.props.languageState.languageId != prevProps.languageState.languageId) {
      const languageOption = LanguageOption.find(
        (option) => option.languageId === this.props.languageState.languageId
      );
      if (languageOption) {
        this.props.i18n.changeLanguage(languageOption.code);
      }
    }

    const currentLanguage = this.props.i18n.language;
    const currentLocation = window.location.href;
    if (
      this.state.location !== currentLocation ||
      this.state.language !== currentLanguage
    ) {
      this.scheduleSeoFetch(currentLanguage, currentLocation);
    }

    if (this.props.authState.isLoggedIn !== prevProps.authState.isLoggedIn) {
      this.startOrStopInterval();
    }
  }

  scheduleSeoFetch(language, location = window.location.href) {
    const seoKey = `${language}|${location}`;
    if (seoKey === this._lastSeoKey || seoKey === this._seoFetchInFlight) {
      return;
    }

    this._seoFetchInFlight = seoKey;
    this.setState({
      location,
      language,
    });

    this.getSeo(language).finally(() => {
      if (this._seoFetchInFlight === seoKey) {
        this._seoFetchInFlight = null;
        this._lastSeoKey = seoKey;
      }
    });
  }

  /// <summary>
  /// Author: -
  /// </summary>
  componentDidCatch(error, errorInfo) {
    this.setState({
      error: error,
      errorInfo: errorInfo,
    });
    this.stopInterval();
  }


  startOrStopInterval() {
    if (this.props.authState.isLoggedIn) {
      this.startInterval();
    } else {
      this.stopInterval();
    }
  }

  startInterval() {
    if (this._checkAuthInterval == null) {
      this._checkAuthInterval = setInterval(() => this.props.checkIsLoggedIn(), 30000);
    }
  }

  stopInterval() {
    if (this._checkAuthInterval != null) {
      clearInterval(this._checkAuthInterval);
      this._checkAuthInterval = null;
    }
  }

  async getSeo(language) {
    try {
      var responseJson = await ApiEngine.get(
        `${ApiUrl._API_GET_SEO_SCRIPTS_LANGUAGE}?LanguageCode=` + language
      );

      if (!responseJson[ApiKey._API_SUCCESS_KEY]) {
        return;
      }

      var data = responseJson[ApiKey._API_DATA_KEY];
      if (!data || !Array.isArray(data)) {
        return;
      }

      var contentLength = data.length;
      var list = [];
      var newData = [];
      var newList = [];
      for (var x = 0; x < contentLength; x++) {
        var rawContent = data[x]["content"] ?? data[x]["Content"];
        var content = safeJsonParse(rawContent);
        if (!content) {
          continue;
        }

        var parameterKeys = Object.keys(content).filter((key) => key.startsWith("parameter_"));
        for (var i = 0; i < parameterKeys.length; i++) {
          var jsonObj = safeJsonParse(content[parameterKeys[i]]);
          if (!jsonObj) {
            continue;
          }
          newData.push({
            name: "PARAMETER " + (i + 1),
            metaType: jsonObj["metaType"],
            content: jsonObj["content"]
          });
        }
        newList = {
          metaType: data[x]["metaDataType"],
          data: newData
        }
        newData = [];
        list.push(newList);
      }
      var titleList = [];
      var meta = [];
      var link = [];
      var script = [];
      var noscript = [];
      var base = [];
      var title = "";

      for (var i = 0; i < list.length; i++) {
        if (list[i].metaType == 'Meta') {
          for (var x = 0; x < list[i].data.length; x++) {
            var content = list[i].data[x].content;
            var jsonObject = safeJsonParse(content);
            if (!jsonObject) {
              continue;
            }
            meta.push({
              page: list[i].data[x].metaType,
              content: jsonObject
            })
          }
        } else if (list[i].metaType == 'Title') {
          for (var x = 0; x < list[i].data.length; x++) {
            titleList.push({
              page: list[i].data[x].metaType,
              content: list[i].data[x].content
            })
          }

        }
        else if (list[i].metaType == 'Link') {
          for (var x = 0; x < list[i].data.length; x++) {
            var content = list[i].data[x].content;
            var jsonObject = safeJsonParse(content);
            if (!jsonObject) {
              continue;
            }
            link.push({
              page: list[i].data[x].metaType,
              content: jsonObject
            })
          }

        }
        else if (list[i].metaType == 'script') {
          for (var x = 0; x < list[i].data.length; x++) {
            var page = list[i].data[x].metaType;
            var content = list[i].data[x].content;
            var jsonObject = safeJsonParse(content);
            if (!jsonObject) {
              continue;
            }
            var code = jsonObject.code.replaceAll("'", `"`);
            jsonObject.code = code;
            script.push({
              page: page,
              content: jsonObject
            });

          }

        }
        else if (list[i].metaType == 'noscript') {
          for (var x = 0; x < list[i].data.length; x++) {
            var page = list[i].data[x].metaType;
            var content = list[i].data[x].content;
            var jsonObject = safeJsonParse(content);
            if (!jsonObject) {
              continue;
            }
            noscript.push({
              page: page,
              content: jsonObject
            });
          }

        }
        else if (list[i].metaType == 'Base') {
          for (var x = 0; x < list[i].data.length; x++) {
            var page = list[i].data[x].metaType;
            var content = list[i].data[x].content;
            var jsonObject = safeJsonParse(content);
            if (!jsonObject) {
              continue;
            }
            base.push({
              page: page,
              content: jsonObject
            });
          }

        }
      }

      var scriptList = [];
      var metaList = [];
      var linkList = [];
      var noscriptList = [];
      var baseList = [];

      if (titleList.length > 0) {
        titleList.filter(title => (title.page == window.location.pathname)).map(content => {
          if (!stringIsNullOrEmpty(content)) {
            title = content.content;
          }
        })

        if (stringIsNullOrEmpty(title)) {
          titleList.filter(title => (title.page == "*")).map(contentAll => {
            title = contentAll.content;
          })
        }
      }

      if (script.length > 0) {
        script.filter(scrips => ((scrips.page == window.location.pathname || scrips.page == "*"))).map(content => {
          if (!stringIsNullOrEmpty(content)) {
            scriptList.push(content.content);
          }
        })
      }

      if (meta.length > 0) {
        meta.filter(metas => (metas.page == "*" || metas.page == window.location.pathname)).map(content => {
          if (!stringIsNullOrEmpty(content)) {
            metaList.push(content.content);
          }
        })
        var list = [];
        var listPage = [];
        if (metaList.length > 0) {
          var filterList = meta.filter(function (obj) {
            if (obj.content.name === "description") {
              list.push(obj.content);
              listPage.push(obj.page);
              return obj.content;
            }
          })
          var i = 0;
          var x = 0;
          while (i < metaList.length) {

            if (metaList[i] === list[x]) {
              metaList.splice(i, 1);
              x++;
            } else {
              ++i;
            }
          }
        }

        listPage.includes(window.location.pathname) ?
          filterList.filter(a => a.page == window.location.pathname).map(content => {
            metaList.push(content.content);
          })
          :
          filterList.filter(a => a.page == "*").map(content => {
            metaList.push(content.content);
          })

      }

      if (link.length > 0) {
        link.filter(links => ((links.page == window.location.pathname || links.page == "*"))).map(content => {
          if (!stringIsNullOrEmpty(content)) {
            linkList.push(content.content);
          }
        })
      }

      if (noscript.length > 0) {
        noscript.filter(noscripts => ((noscripts.page == window.location.pathname || noscripts.page == "*"))).map(content => {
          if (!stringIsNullOrEmpty(content)) {
            noscriptList.push(content.content);
          }
        })
      }

      if (base.length > 0) {
        base.filter(bases => ((bases.page == window.location.pathname || bases.page == "*"))).map(content => {
          if (!stringIsNullOrEmpty(content)) {
            baseList.push(content.content);
          }
        })
      }

      this.setState({
        baseList,
        noscriptList,
        scriptList,
        linkList,
        title,
        metaList,
        seo: list,
      });
    } catch (error) {
      console.error("Error fetching SEO data:", error);
    }
  }

  render() {
    const { seo, metaList, title, linkList, scriptList, noscriptList, baseList, location, language } = this.state;
    if (this.state.errorInfo) {
      return (
        <div className="error" style={{ padding: "20px" }}>
          <img
            src="/img/error.png"
            style={{
              maxWidth: "100px",
              objectFit: "contain",
              marginLeft: "auto",
              marginRight: "auto",
            }}
            alt="error"
          />
          <h3>Something went wrong, please contact admin for help</h3>
          <div className="m-b-30">{window.navigator.userAgent}</div>
        </div>
      );
    } else {
      return (
        <PageSettings.Provider value={this.state}>
          <Helmet
            title={title}
            meta={metaList}
            link={linkList}
          >
            <base href={location} />
          </Helmet>
          {scriptList &&
            scriptList.length > 0 &&
            scriptList.map(({ code, type, id, src }, index) => (
              <Helmet key={index}>
                <script key={index} src={src} id={id} type={type}>
                  {code}
                </script>
              </Helmet>
            ))
          }

          {noscriptList &&
            noscriptList.length > 0 &&
            noscriptList.map(({ code }, index) => (
              <Helmet key={index}>
                <noscript>
                  {code}
                </noscript>
              </Helmet>
            ))
          }
          <LoadingOverlay
            active={
              this.props.appState.isBusy ||
              !this.props.authState.loginStateInitialized
            }
            styles={{
              overlay: (base) => ({
                ...base,
                zIndex: "10000",
                position: "fixed",
              }),
            }}
            className={classNames("loading-overlay")}
              >
                  
                  {/*<div className="loader">
                      <img src={"/img/logo_blue.png"} />
                  </div>*/}
                  <b className="loader-font">{this.props.appState.message + "..."}</b>
          </LoadingOverlay>
          {!isObjectEmpty(this.props.appState.alert) && (
            <div className="sweet-alert-container">
              {/*console.log({
                ...this.props.appState.alert,
                onConfirm: this.props.appState.alert.onConfirm ?? this.props.disposeMessage()

              }) */}
              <SweetAlert {...this.props.appState.alert}>
                {!stringIsNullOrEmpty(this.props.appState.alert.content) &&
                  (this.props.appState.alert.html
                    ? this.props.appState.alert.content
                    : this.props.appState.alert.content
                        .split("\n")
                        .map((item, key) => {
                          return (
                            <span key={key} className="sweet-alert-content">
                              {item}
                              <br />
                            </span>
                          );
                        }))}
              </SweetAlert>
            </div>
          )}
          {this.props.authState.loginStateInitialized && (
            <div
              className={
                (this.state.hasCustomSkin === true
                  ? "custom-skin-background "
                  : "") +
                classNames("fade page-sidebar-fixed show page-container", {
                  "page-content-full-height": this.state.pageContentFullHeight,
                })
              }
              style={{
                minHeight: "100vh",
                height: "100%",
                backgroundSize:
                  this.props.authState.userData.selectedTheme === 1
                    ? "cover"
                    : "contain",
              }}
            >
              <div
                onClick={() => {
                  if (this.state.pageSidebarToggled) {
                    this.toggleMobileSidebar();
                  }
                }}
              >
                {this.state.pageContent && <Content />}
              </div>
            </div>
          )}
        </PageSettings.Provider>
      );
    }
  }
}

const mapStateToProps = (state) => {
  return ({
    ...state,
  })
};

const mergeProps = (stateProps, dispatchProps, ownProps) => {
  var alert = {};
  if (Object.keys(stateProps.appState.alert).length > 0 && !stateProps.appState.alert.onConfirm) {
    alert = {
      ...stateProps.appState.alert,
      onConfirm: dispatchProps.disposeMessage
    }
    stateProps.appState.alert = { ...alert };
  }
  
  return ({ ...stateProps, ...dispatchProps, ...ownProps });
}

export default connect(mapStateToProps, {
  updateLoginUser: updateLoginUser,
  resetLogin: resetLogin,
  performLogout: performLogout,
  checkIsLoggedIn: checkIsLoggedIn,
  disposeMessage: disposeMessage
}, mergeProps)(withTranslation()(App));
